import home from "../src/components/home/home";

import profileIndex from "../src/components/profile/index";
import profileRouter from "./profile/index";

import committeeIndex from "../src/components/committees/index";
import committeeRouter from "./committee/index";

import communityIndex from "../src/components/community/index";
import communityRouter from "./community/index";

import itemgroupIndex from "../src/components/itemgroup/index";
import itemgroupRouter from "./itemgroup/index";

import itemIndex from "../src/components/item/index";
import itemRouter from "./item/index";

import settingIndex from "../src/components/settings/index";
import settingRouter from "./settings/index";
import absence from "../src/components/events/absence.vue";

export default [
  {
    path: "/home",
    name: "home",
    component: home,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/profile",
    component: profileIndex,
    children: profileRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/committees",
    component: committeeIndex,
    children: committeeRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/groups",
    name: "groups",
    component: committeeIndex,
    children: committeeRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/itemgroups",
    name: "itemgroups",
    component: itemgroupIndex,
    children: itemgroupRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/items",
    name: "items",
    component: itemIndex,
    children: itemRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/community",
    name: "community",
    component: communityIndex,
    children: communityRouter,
    meta: {
      AuthRequired: true,
    },
  },

  {
    path: "/settings",
    name: "settings",
    component: settingIndex,
    children: settingRouter,
    meta: {
      AuthRequired: true,
    },
  },
  {
    path: "/absence/:token",
    name: "absence-token",
    component: absence,
    meta: {
      AuthRequired: true,
    },
  },
];
